import React from 'react';
import MainTitle from '../../components/page/main-title/MainTitle';
import Button from '../../components/buttons/Button';
import TextInput from '../../components/form/TextInput';
import TextInputWithUploader from '../../components/form/TextInputWithUploader';
import TextArea from "../../components/form/TextArea";
import Random from "../../utils/strings/Random";
import ReactDOM from "react-dom";
import SEXOS from "../../data/Sexos";
import ItemSimplesListagem from '../../components/listagem/ItemSimplesListagem';
import Component from "./Component";
import Select from "../../components/form/Select";
import STRINGS from './../../data/language/language';
import WS from '../../config/Ws';
import Requisitions from '../../utils/requisitions/Requisitions';
import Dialog from '../../components/alert/Dialog';
import {FormDataToJson} from '../../utils/json/Json';
import PAGES from '../../config/Pages';

const URL_SAVE = WS.blocos.save;

class Page extends React.Component{
  constructor (props){
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      wrapper: Random(7),
      strings: STRINGS[window.LANGUAGE],
      detalhe: props.detalhe
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {

  }

  handleSubmit (e){
    e.preventDefault();
    const _self = this;
    const {
      atencao,
      salvoSucesso,
      erroSalvarBloco,
      preenchaCamposAsterisco,
      escolhaOsExercicios,
      erroSalvar
    }
    = this.state.strings;

    const formData = new FormData(e.target);

    //retorna todos os exercicios adicionados
    let idForm = e.target.getAttribute('id');
    let elements = document.getElementById(idForm).querySelectorAll('.item-listagem');
    var exercicios = [];

    //transforma o formData em um json
    var object = FormDataToJson(formData);

    if(!object.nome){
      let msg = {
        title: atencao,
        text:preenchaCamposAsterisco
      };
      Dialog.create(msg);
      return false;
    }

    //é obrigatório adicionar exercícios
    if(elements.length<=0){
      let msg = {
        title: atencao,
        text:escolhaOsExercicios
      };
      Dialog.create(msg);
      return false;
    }

    elements.forEach((value, key)=>{
      let idEl = value.getAttribute('data-id');
      if(idEl){
        exercicios.push(idEl);
      }

    });

    object.exercicios = exercicios;

    //----------------

    const history = this.props.history;

    Requisitions({
      url:URL_SAVE,
      data: object,
      sucess:function(data){
        var msg;
        _self.props.modal.close();
        msg = {
          title: atencao,
          text: data.msg
        };
        Dialog.create(msg);
        history.push(PAGES.blocos);
      },
      error:function(data){
        Dialog.create({
          title: atencao,
          text: erroSalvar
        });
      }
    });
  }

  render (){
    const { cadastroBloco, nomeBloco, observacoes, salvar, digiteAqui, sexo } = this.state.strings;
    const valNomeBloco = this.props.detalhe ? this.props.detalhe.nome : '';
    const observacoesBloco = this.props.detalhe ? this.props.detalhe.observacoes : '';
    let sexoBloco = '';

    if(this.props.detalhe){
      sexoBloco = this.props.detalhe.sexo === 'm' ? SEXOS[0] : SEXOS[1];
    }else{
      if(this.props.sexo){
        sexoBloco = this.props.sexo === 'M' ? SEXOS[0] : SEXOS[1];
      }
    }

    const sexoSigla = this.props.sexo;

    return (
      <div className='box-cadastro-bloco'>
        <MainTitle title={cadastroBloco}></MainTitle>
        <form id={this.state.wrapper} onSubmit={this.handleSubmit}>
          <div className="pure-u-15-24">
            <TextInput name="nome" title={nomeBloco+"*"} placeholder={digiteAqui} value={valNomeBloco} />
          </div>
          <div className="pure-u-15-24" style={{display: 'none'}}>
            <Select title={sexo} value={sexoBloco} name='sexo' options={SEXOS}/>
          </div>
          <Component wrapper={this.state.wrapper} detalhe={this.props.detalhe} sexo={sexoSigla}></Component>
          <br/><br/>
          <div className="box-right-button"><Button type="submit" text={salvar} classes="bt-save bt-blue" /></div>
        </form>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/classes/blocos/Page.js